import { render, staticRenderFns } from "./cd.vue?vue&type=template&id=67071118&scoped=true&"
import script from "./cd.vue?vue&type=script&lang=js&"
export * from "./cd.vue?vue&type=script&lang=js&"
import style0 from "./cd.vue?vue&type=style&index=0&id=67071118&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67071118",
  null
  
)

export default component.exports